@let pathValue = path();
@let isbuttonBackDisabled = buttonBackDisabled();

<div class="file-browser">
  <div class="file-browser__navigation">
    <div class="file-browser__header">
      <div class="file-browser__back">
        <button
          class="file-browser__button file-browser__button--back"
          [class.file-browser__button--disabled]="isbuttonBackDisabled"
          [disabled]="isbuttonBackDisabled"
          (click)="back(pathValue.length)"
        >
          <unis-icon
            font="regular"
            icon="arrow-circle-left"
          />
          <span class="file-browser__button-text">{{ 'FILE_BROWSER.BACK' | translate }}</span>
        </button>
      </div>
    </div>

    <div class="file-browser__sources">
      <ng-content select="[sources]"></ng-content>
    </div>
  </div>

  <div class="file-browser__container">
    <evi-desktop-breadcrumb
      class="file-browser__breadcrumb"
      [path]="pathValue"
      (selectFolder)="onFolderSelection($event.folder)"
    ></evi-desktop-breadcrumb>

    <div class="file-browser__list-container">
      @if (loading()) {
        <div class="file-browser__list-empty">
          {{ 'FILE_BROWSER.LOADING_FILES' | translate }}
        </div>
      } @else {
        <ng-content select="[loadedLists]"></ng-content>
      }
    </div>
  </div>
</div>
